import { FormattedMessage } from 'react-intl';

export default function AdminConsolePlaceholder() {
  return (
    <div className="AdminConsolePlaceholder">
      <FormattedMessage id="labels.comingSoon" />
    </div>
  );
}
